import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoTipologica } from '../../../../common/models/tipologiche/tipo-tipologica';

export class FascicoloSinistroSanitario extends FascicoloFull {
  dataSinistro: number;
  dataDenuncia: number;
  nSinistro: number;
  canaleApertura: TipoTipologica;
  tipoGestioneSinistro: string;
  protocolloDenuncia: string;
  tipoResponsabilita: string;
  //tipoSinistro: string
  descrizione: string;
  luogo: string;
  presidioDistretto: TipoTipologica;
  tipoDanno: TipoTipologica; 
  morte: boolean;
  tipoValutazione: TipoTipologica;
  statoLavorazione: TipoTipologica;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
